import { PublishMenuButton } from "./PublishMenuButton";
import { useAsyncPublishButton } from "../../../publish/publish-menu/useAsyncPublishButton";

export interface AsyncPublishMenuButtonProps {
    entryId: string;
    isIdle?: boolean;
    entryName?: string;
}

/**
 * async wrapper to the PublishMenuButton component
 * asynchronously get publish menu props for a given entry id
 * used in:
 * upload media single entry action, express recorder single entry action
 */
export function AsyncPublishMenuButton({ entryId, isIdle, entryName }: AsyncPublishMenuButtonProps) {
    const data = useAsyncPublishButton(entryId, isIdle);

    return <PublishMenuButton buttonAnalyticsActionName={"View publishing status"} entryName={entryName} {...data} />;
}

export default AsyncPublishMenuButton;
